import { withTranslate } from "react-admin";
import { takeLatest, put } from "redux-saga/effects";
import { appendSongToPlaylist } from "../../services/dataProvider";
import { OPEN_DIALOG } from "./../../store/actions/dialogActions";
import {
  ADD_SONG_TO_PLAYLIST_REQUEST,
  addSongToPlayList,
} from "./../../store/actions/playList";
let song, playlist;
function* addSongToPlaylistHandler(action) {
  console.log("playlist action", action);
  playlist = action.payload.playlist;
  console.log("song", song);
  if (song.id !== undefined) {
    try {
      const res = yield appendSongToPlaylist(song.id, playlist);
    } catch (e) {
      //send action for request error here
    }
    yield put(addSongToPlayList(song.id, playlist));
  }
}
function* watchPlaylistSelect(action) {
  song = action.payload.song;
  console.log("action song", song);
  yield takeLatest(ADD_SONG_TO_PLAYLIST_REQUEST, addSongToPlaylistHandler);
}
export default function* playlistSaga() {
  yield takeLatest(OPEN_DIALOG, watchPlaylistSelect);
}
